/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { ExtensibleNode } from '../../core/models/ExtensibleNode';
import { IReferenceNode } from '../../core/models/IReferenceNode';
import { Node } from '../../core/models/Node';
import { ExternalDocumentation } from '../../core/models/common/ExternalDocumentation';
import { INamed } from '../../core/models/common/INamed';
import { Tag } from '../../core/models/common/Tag';

/**
 * Constructor.
 * @param {Node} parent
 * @param {string} name
 * @class
 * @extends ExtensibleNode
 * @author Jakub Senko <jsenko@redhat.com>
 */
export abstract class AaiMessageBase extends ExtensibleNode implements IReferenceNode, INamed {
    public _name : string;

    public $ref : string;

    /**
     * Represents `Schema Object | Reference Object` type.
     */
    public headers : AaiHeaderItem;

    public correlationId : AaiCorrelationId;

    public schemaFormat : string;

    public contentType : string;

    public name : string;

    public title : string;

    public summary : string;

    public description : string;

    public tags : Array<Tag>;

    public externalDocs : ExternalDocumentation;

    public bindings : AaiMessageBindings;

    /**
     * Represents `Map[string, any]` type.
     * <p>
     * Objects of `any` type are deserialized as follows:
     * In TypeScript, this field contains the raw JS object, in case of Java
     * it is a {@link com.fasterxml.jackson.databind.node.ObjectNode}.
     * 
     * @see <a href="https://www.asyncapi.com/docs/specifications/2.0.0/#schemaObject">AsyncAPI 2.0.0 spec</a>
     */
    public examples : any;

    public constructor(parent? : any, name? : any) {
        if(((parent != null && parent instanceof <any>Node) || parent === null) && ((typeof name === 'string') || name === null)) {
            let __args = arguments;
            {
                let __args = arguments;
                super();
                if(this._name===undefined) this._name = null;
                if(this.$ref===undefined) this.$ref = null;
                if(this.headers===undefined) this.headers = null;
                if(this.correlationId===undefined) this.correlationId = null;
                if(this.schemaFormat===undefined) this.schemaFormat = null;
                if(this.contentType===undefined) this.contentType = null;
                if(this.name===undefined) this.name = null;
                if(this.title===undefined) this.title = null;
                if(this.summary===undefined) this.summary = null;
                if(this.description===undefined) this.description = null;
                if(this.tags===undefined) this.tags = null;
                if(this.externalDocs===undefined) this.externalDocs = null;
                if(this.bindings===undefined) this.bindings = null;
                if(this.examples===undefined) this.examples = null;
                if(this._name===undefined) this._name = null;
                if(this.$ref===undefined) this.$ref = null;
                if(this.headers===undefined) this.headers = null;
                if(this.correlationId===undefined) this.correlationId = null;
                if(this.schemaFormat===undefined) this.schemaFormat = null;
                if(this.contentType===undefined) this.contentType = null;
                if(this.name===undefined) this.name = null;
                if(this.title===undefined) this.title = null;
                if(this.summary===undefined) this.summary = null;
                if(this.description===undefined) this.description = null;
                if(this.tags===undefined) this.tags = null;
                if(this.externalDocs===undefined) this.externalDocs = null;
                if(this.bindings===undefined) this.bindings = null;
                if(this.examples===undefined) this.examples = null;
                (() => {
                    if(parent != null) {
                        this._parent = parent;
                        this._ownerDocument = parent.ownerDocument();
                    }
                })();
            }
            (() => {
                this._name = name;
            })();
        } else if(((typeof parent === 'string') || parent === null) && name === undefined) {
            let __args = arguments;
            let name : any = __args[0];
            super();
            if(this._name===undefined) this._name = null;
            if(this.$ref===undefined) this.$ref = null;
            if(this.headers===undefined) this.headers = null;
            if(this.correlationId===undefined) this.correlationId = null;
            if(this.schemaFormat===undefined) this.schemaFormat = null;
            if(this.contentType===undefined) this.contentType = null;
            if(this.name===undefined) this.name = null;
            if(this.title===undefined) this.title = null;
            if(this.summary===undefined) this.summary = null;
            if(this.description===undefined) this.description = null;
            if(this.tags===undefined) this.tags = null;
            if(this.externalDocs===undefined) this.externalDocs = null;
            if(this.bindings===undefined) this.bindings = null;
            if(this.examples===undefined) this.examples = null;
            if(this._name===undefined) this._name = null;
            if(this.$ref===undefined) this.$ref = null;
            if(this.headers===undefined) this.headers = null;
            if(this.correlationId===undefined) this.correlationId = null;
            if(this.schemaFormat===undefined) this.schemaFormat = null;
            if(this.contentType===undefined) this.contentType = null;
            if(this.name===undefined) this.name = null;
            if(this.title===undefined) this.title = null;
            if(this.summary===undefined) this.summary = null;
            if(this.description===undefined) this.description = null;
            if(this.tags===undefined) this.tags = null;
            if(this.externalDocs===undefined) this.externalDocs = null;
            if(this.bindings===undefined) this.bindings = null;
            if(this.examples===undefined) this.examples = null;
            (() => {
                this._name = name;
            })();
        } else if(((parent != null && parent instanceof <any>Node) || parent === null) && name === undefined) {
            let __args = arguments;
            super();
            if(this._name===undefined) this._name = null;
            if(this.$ref===undefined) this.$ref = null;
            if(this.headers===undefined) this.headers = null;
            if(this.correlationId===undefined) this.correlationId = null;
            if(this.schemaFormat===undefined) this.schemaFormat = null;
            if(this.contentType===undefined) this.contentType = null;
            if(this.name===undefined) this.name = null;
            if(this.title===undefined) this.title = null;
            if(this.summary===undefined) this.summary = null;
            if(this.description===undefined) this.description = null;
            if(this.tags===undefined) this.tags = null;
            if(this.externalDocs===undefined) this.externalDocs = null;
            if(this.bindings===undefined) this.bindings = null;
            if(this.examples===undefined) this.examples = null;
            if(this._name===undefined) this._name = null;
            if(this.$ref===undefined) this.$ref = null;
            if(this.headers===undefined) this.headers = null;
            if(this.correlationId===undefined) this.correlationId = null;
            if(this.schemaFormat===undefined) this.schemaFormat = null;
            if(this.contentType===undefined) this.contentType = null;
            if(this.name===undefined) this.name = null;
            if(this.title===undefined) this.title = null;
            if(this.summary===undefined) this.summary = null;
            if(this.description===undefined) this.description = null;
            if(this.tags===undefined) this.tags = null;
            if(this.externalDocs===undefined) this.externalDocs = null;
            if(this.bindings===undefined) this.bindings = null;
            if(this.examples===undefined) this.examples = null;
            (() => {
                if(parent != null) {
                    this._parent = parent;
                    this._ownerDocument = parent.ownerDocument();
                }
            })();
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.core.models.common.INamed#getName()
     * @return {string}
     */
    public getName() : string {
        return this._name;
    }

    /**
     * @see io.apicurio.datamodels.core.models.common.INamed#rename(java.lang.String)
     * @param {string} newName
     */
    public rename(newName : string) {
        this._name = newName;
    }

    /**
     * 
     * @return {string}
     */
    public getReference() : string {
        return this.$ref;
    }

    /**
     * 
     * @param {string} reference
     */
    public setReference(reference : string) {
        this.$ref = reference;
    }

    public abstract addTag(tag : AaiTag);
}
AaiMessageBase["__class"] = "io.apicurio.datamodels.asyncapi.models.AaiMessageBase";
AaiMessageBase["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.IReferenceNode","io.apicurio.datamodels.core.models.common.INamed"];





import { AaiTag } from './AaiTag';


import { AaiMessageBindings } from './AaiMessageBindings';


import { AaiCorrelationId } from './AaiCorrelationId';


import { AaiHeaderItem } from './AaiHeaderItem';

